/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} NoInputs */

const en_no = /** @type {(inputs: NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

const de_no = /** @type {(inputs: NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein`)
};

/**
* | output |
* | --- |
* | "No" |
*
* @param {NoInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const no = /** @type {((inputs?: NoInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<NoInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_no(inputs)
	return en_no(inputs)
});